import React from 'react';
import Navbar from 'components/navbar/Navbar';
import Footer from 'components/footer';
import navbarStore from 'components/navbar/NavbarStore';
import footerStore from 'components/footer/FooterStore';
import {getHeadingTitle, replaceAssetsImgUrl, calcBackgroundFullWidth} from 'cms/helpers/common';
import {cms, isAirtickets} from 'helpers/stableValues';
import notFoundImageAT from 'assets/images/static/bg-static-at.jpg';
import notFoundImageTP from 'assets/images/static/bg-static-tp.jpg';

const WebLayout = () => {
  const getBackgrounImg = () => {
    const width = calcBackgroundFullWidth();
    if (typeof cms.image === 'string') {
      return replaceAssetsImgUrl(cms.image, width);
    } else if (isAirtickets) {
      return replaceAssetsImgUrl(notFoundImageAT, width);
    }
  
    return replaceAssetsImgUrl(notFoundImageTP, width);
  };
  return (
    <>
      <Navbar navbar={navbarStore} />
      <section className="position-relative" style={{height: '320px'}}>
        <img
          className="position-absolute w-1-1 h-1-1 img-cover"
          src={getBackgrounImg()}
        />
        <div className="position-relative bg-overlay h-1-1">
          <div className="container d-flex align-items-center justify-content-center h-1-1">
            <h1
              className="display-2 text-light text-center w-lg-1-2 mx-auto"
              dangerouslySetInnerHTML={{__html: getHeadingTitle(cms.h1, cms.title)}}
            />
          </div>
        </div>
      </section>
      <section className="bg-white py-6">
        <div className="container">
          <div className="w-lg-6-10 mx-auto" dangerouslySetInnerHTML={{__html: cms.content.rendered}} />
        </div>
      </section>
      <Footer store={footerStore} />
    </>
  );
};

export default WebLayout;